import { Css, StatusBanner, useSnackbar, useTestIds } from "@homebound/beam";
import { BidPackageDetailPageDocument } from "src/routes/bids/BidPackageDetailPage.generated";
import { useReviewBidPackageIncomingUpdatesMutation } from "src/routes/bids/components/ReviewBidPackageIncomingUpdates.generated";
import { ReviewScopeChangesCard_IncomingUpdateFragment } from "src/routes/bids/components/ReviewScopeChangesCard.generated";
import { PlanBasedBidsTableV2_BidPlanChildGroupsDocument } from "src/routes/bids/plan-based-bid-package/components/PlanBasedBidsTableV2.generated";

type ReviewScopeChangesCardProps = {
  bidPackageId: string;
  productOfferingId: string;
  planName: string;
  updates: readonly ReviewScopeChangesCard_IncomingUpdateFragment[];
};

export function ReviewScopeChangesCard(props: ReviewScopeChangesCardProps) {
  const { bidPackageId, productOfferingId, planName, updates } = props;
  const [reviewUpdates, { loading }] = useReviewBidPackageIncomingUpdatesMutation();
  const { triggerNotice } = useSnackbar();
  const tid = useTestIds({});
  if (updates.isEmpty) return null;
  const latestVersion = updates.map((u) => u.source.version ?? 0).max();

  async function onMarkReviewed() {
    await reviewUpdates({
      variables: { input: { bidPackageId, productOfferingId } },
      refetchQueries: [BidPackageDetailPageDocument, PlanBasedBidsTableV2_BidPlanChildGroupsDocument],
    });
    triggerNotice({ message: "Scope changes marked as reviewed." });
  }

  return (
    <div css={Css.mb2.$}>
      <StatusBanner
        {...tid.card}
        type="info"
        icon="refresh"
        title={`Scope updates from ${planName} v${latestVersion}`}
        description="Please review scope changes detailed below. Scope updates will never remove costs from your bid."
        secondaryAction={{ label: "Mark as Reviewed", disabled: loading, onClick: onMarkReviewed }}
      />
    </div>
  );
}
